export default __webpack_public_path__ + "static/media/nodejs.615ffbea.svg";